import { API_BASE } from '../../api';

/**
 * Endereço COMPLETO que o provedor chama para entregar as mensagens: a origem desta tela + a base da
 * API + o caminho que o servidor informa (`/webhooks/...`). É o que o administrador cadastra no
 * painel do provedor.
 */
export function webhookUrl(
  path: string,
  base: string = API_BASE,
  href: string = window.location.href,
): string {
  return new URL(`${base}${path}`, href).toString();
}

/**
 * O provedor só entrega em endereço PÚBLICO e com HTTPS: localhost, IP privado ou HTTP simples
 * nunca recebem nada. Serve para avisar antes de a pessoa perder tempo cadastrando-o.
 */
export function isPublicHttps(address: string): boolean {
  let url: URL;
  try {
    url = new URL(address);
  } catch {
    return false;
  }
  if (url.protocol !== 'https:') return false;
  const host = url.hostname.toLowerCase();
  if (host === 'localhost' || host.endsWith('.localhost') || host.endsWith('.local')) return false;
  // IPv4 privado/loopback e IPv6 local: não são alcançáveis de fora.
  if (
    /^(127|10)\./.test(host) ||
    /^192\.168\./.test(host) ||
    /^172\.(1[6-9]|2\d|3[01])\./.test(host)
  ) {
    return false;
  }
  return !(
    host === '[::1]' ||
    host.startsWith('[fc') ||
    host.startsWith('[fd') ||
    host.startsWith('[fe80')
  );
}
